import { useRef, useEffect } from "react";
import { motion } from "framer-motion";

export const PopupMenu = ({ moreMenuResumeId, setMoreMenuResumeId, moreBtnRef, optionsBtnList, className }) => {
    
    const menuRef = useRef();
    // Click outside handler
    useEffect(() => {
        if (!moreMenuResumeId) return;
        function handleClickOutside(event) {
            setTimeout(() => {
                if (menuRef.current && !menuRef.current.contains(event.target) &&
                    moreBtnRef.current && !moreBtnRef.current.contains(event.target)) {
                    setMoreMenuResumeId(null);
                }
              }, 100);
              
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [moreMenuResumeId, moreBtnRef, setMoreMenuResumeId]);

    return (
        
        <motion.div
            ref={menuRef}
            initial={{ opacity: 0, y: -10, scale: 0.9 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: -10, scale: 0.9 }}
            transition={{ duration: 0.2 }}
            className={className || "absolute -right-10 top-8 z-10 bg-white border rounded shadow-lg w-32 overflow-hidden"}
            >
            {optionsBtnList.map((option, idx) => (
                <div key={option.label} className="text-black">
                <button
                    className="w-full text-left px-4 py-2 hover:bg-indigo-50 focus:bg-indigo-50"
                    onClick={option.onClick}
                >
                    {option.label}
                </button>
                {idx < optionsBtnList.length - 1 && (
                    <div className="border-t border-gray-200" />
                )}
                </div>
            ))}
        </motion.div>      
      

      );
      
}
